import React from "react";
import { notification, Modal } from "antd";

const { confirm, warning, info } = Modal;

/**
 *
 * @param {*} type - string, must be: 'success', 'info', 'warning' or 'error
 * @param {*} message - the title
 * @param {*} description
 */
export const Toast = ({type, message, description}) => {
  
  notification.config({
    top: 60,
    duration: type === 'error' ? 0 : 5  // errors won't close automatically
  });

  const openNotificationWithIcon = (type) => {
    let dsc =  (description ||'').replace(/\\n/g, "\n");
    let msg = (message||'').replace(/\\n/g, "\n");

      notification[type]({
          message: msg,
          description: dsc.split("\n").map((text, i) => i ? [<br/>, text] : text),
      });
  };

  return openNotificationWithIcon(type);
}



export const Confirm = async (key, {title, content}, cb) => {

  return confirm({
            zIndex:2000,
            title,
            content: content.split("\n").map((text, i) => i ? [<br/>, text] : text),
            onOk() {
              cb(key, true);
            },
            onCancel() {
              cb(key, false);
            }
        });

};

export const Understood = async (key, {title, content}, cb) => {

  return warning({
            zIndex:2000,
            title,
            content: content.split("\n").map((text, i) => i ? [<br/>, text] : text),
            onOk() {
              cb(key)
            }
        });
};

export const Reason = async (key, {title, content}, cb) => {

  return confirm({
            zIndex:2000,
            title,
            content: content.split("\n").map((text, i) => i ? [<br/>, text] : text),
            onOk() {
              cb(key, true, content)
            },
            onCancel() {
              cb(key, false, content);
            }
        });
};


// WEBPACK FOOTER //
// ./src/Components/Notification/index.js